module.exports = __webpack_public_path__ + "img/1.1a5a7ee2.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":978,"height":604,"variants":[{"file":"img/1-480w.5b92a9409e1a.webp","width":480},{"file":"img/1-960w.7e1f61072ce1.webp","width":960},{"file":"img/1-978w.3cf803cde0e7.webp","width":978}]};
}